import { render, staticRenderFns } from "./pdp-review-date.vue?vue&type=template&id=8099973e"
import script from "./pdp-review-date.vue?vue&type=script&lang=js"
export * from "./pdp-review-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports